<template>
  <OrderTemplate
    :custom-page="customPage"
    page-type="create"
  />
</template>

<script setup>
import { OrderTemplate } from '../../OrderTemplate/'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

const customPage = computed(() => ({
  headerTitle: t('orderCreate.title'),
  buttonText: t('orderCreate.button'),
}))
</script>
